<div class="product-info-container">
  <div class="content">
    <div class="headline">{{ 'pdp.info.productInfo.headline' | translate }}</div>
    <div class="text">
      <div class="info">
        <markdown [data]="info"></markdown>
        <markdown [data]="applications"></markdown>
      </div>
      <div class="usp">
        <ul>
          <li *ngFor="let usp of usps">{{ usp }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
